import React, { createContext, useContext, useState } from 'react';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
    const [token, setToken] = useState(localStorage.getItem('adminToken'));

    const login = (tok) => {
        localStorage.setItem('adminToken', tok);
        setToken(tok);
    };

    const logout = () => {
        localStorage.removeItem('adminToken');
        setToken(null);
    };

    return (
        <AdminAuthContext.Provider value={{ token, login, logout, isAuthenticated: !!token }}>
            {children}
        </AdminAuthContext.Provider>
    );
}

export function useAdminAuth() {
    return useContext(AdminAuthContext);
}
